import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import CardDescription from '../CardDescription/CardDescription'
import ChartGroupBySelect from '../ChartGroupBySelect/ChartGroupBySelect'
import InfoTooltip from '../InfoTooltip/InfoTooltip'
import MenuCard from '../MenuCard/MenuCard'
import ProductsList from './ProductsList/ProductsList'
import ProductsSearchInput from './ProductsSearchInput/ProductsSearchInput'
import * as Styles from './styles'

const ProductsCard = ({
  products,
  productsFilters,
  onChangeProductsFilters,
  loading,
  onExport,
  provider,
  onClickProduct,
  onClickVariant,
  onClickCategory,
  onClickType,
  onClickCollection,
  showGroupBySelector = true,
  showExport = true,
  title,
  description,
  tooltip,
  showSearch = true,
  rateLabel,
  Icon,
  salesOrdersDataActivated,
  carbonOffset,
  isUnifiedDashboard,
  sizeRecommendationsCount,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleGroupByChange = value => {
    onChangeProductsFilters({ ...productsFilters, groupBy: value, query: '' })
  }

  const handleSearch = value => {
    onChangeProductsFilters({ ...productsFilters, query: value })
  }

  return (
    <Card showBorder={false}>
      <CardTitle marginBottom={theme.spacing.sp16}>
        <Styles.HeaderTitleContainer>
          <Styles.Title>
            {Icon && <Icon size={24} weight="light" />} {title}
          </Styles.Title>
          {showGroupBySelector && (
            <ChartGroupBySelect value={productsFilters?.groupBy} onChange={handleGroupByChange} provider={provider} />
          )}
        </Styles.HeaderTitleContainer>
        <Styles.Actions>
          {tooltip && <InfoTooltip text={tooltip} />}
          {showExport && <MenuCard cardName={t('Más devueltos')} onExport={onExport} />}
        </Styles.Actions>
      </CardTitle>
      {description && <CardDescription>{description}</CardDescription>}
      {showSearch && (
        <ProductsSearchInput
          key={productsFilters?.groupBy}
          groupBy={productsFilters?.groupBy}
          onSearch={handleSearch}
          initialValue={productsFilters?.query}
        />
      )}
      <ProductsList
        products={products}
        productsFilters={productsFilters}
        onChangeProductsFilters={onChangeProductsFilters}
        loading={loading}
        onClickProduct={onClickProduct}
        onClickVariant={onClickVariant}
        onClickCategory={onClickCategory}
        onClickType={onClickType}
        onClickCollection={onClickCollection}
        salesOrdersDataActivated={salesOrdersDataActivated}
        carbonOffset={carbonOffset}
        isUnifiedDashboard={isUnifiedDashboard}
        sizeRecommendationsCount={sizeRecommendationsCount}
        rateLabel={rateLabel}
      />
    </Card>
  )
}

export default ProductsCard
